/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_CreatedInputs */

const en_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume created`)
};

const de_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf erstellt`)
};

const fr_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV créé`)
};

const es_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum creado`)
};

const it_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum creato`)
};

const nl_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV gemaakt`)
};

const pl_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV utworzone`)
};

const fi_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo luotu`)
};

const da_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV oprettet`)
};

const sv_onboarding_resume_created = /** @type {(inputs: Onboarding_Resume_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV skapat`)
};

/**
* | output |
* | --- |
* | "Resume created" |
*
* @param {Onboarding_Resume_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_created = /** @type {((inputs?: Onboarding_Resume_CreatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_CreatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_created(inputs)
	if (locale === "fr") return fr_onboarding_resume_created(inputs)
	if (locale === "es") return es_onboarding_resume_created(inputs)
	if (locale === "it") return it_onboarding_resume_created(inputs)
	if (locale === "nl") return nl_onboarding_resume_created(inputs)
	if (locale === "pl") return pl_onboarding_resume_created(inputs)
	if (locale === "fi") return fi_onboarding_resume_created(inputs)
	if (locale === "da") return da_onboarding_resume_created(inputs)
	if (locale === "sv") return sv_onboarding_resume_created(inputs)
	return en_onboarding_resume_created(inputs)
});